/**
 * NFeFinalizePage Component
 * 
 * Página para criar rascunhos de NF-e modelo 55.
 * Cria um novo rascunho e redireciona para a página de edição.
 */

import { useState, useEffect, useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { useToast } from '../../../../hooks/useToast'
import { nfeService } from '../../../../services/erpApi'
import './NFeEditPage.css'

function NFeFinalizePage() {
  const navigate = useNavigate()
  const { saleId } = useParams()
  const { showToast } = useToast()

  const [loading, setLoading] = useState(false)

  // Criar novo rascunho
  const createNewDraft = useCallback(async () => {
    setLoading(true)
    try {
      const response = await nfeService.criarRascunho({
        customerId: null,
        observation: null
      })
      
      if (response.success && response.data?.id) {
        // Redirecionar para a página de edição
        navigate(`/erp/vendas/nfe/${response.data.id}/editar`, { replace: true })
      } else {
        showToast(response.message || 'Erro ao criar rascunho', 'error')
        navigate('/erp/vendas/nfe')
      }
    } catch (error) {
      console.error('Erro ao criar rascunho:', error)
      showToast('Erro ao criar rascunho de NF-e', 'error')
      navigate('/erp/vendas/nfe')
    } finally {
      setLoading(false)
    }
  }, [navigate, showToast])

  // Carregar dados iniciais
  useEffect(() => {
    // Se tiver saleId, criar rascunho a partir da venda
    // Caso contrário, criar um rascunho vazio
    createNewDraft()
  }, [saleId, createNewDraft])

  if (loading) {
    return (
      <div className="nfe-edit-page loading">
        <Loader2 className="spinner" size={32} />
        <p>Criando rascunho...</p>
      </div>
    )
  }

  // Esta página apenas redireciona, então não renderiza nada
  return null
}

export default NFeFinalizePage
